import { fetchWithTimeout } from './fetchWithTimeout';
import { Store } from './store';

export type CarQueue = {
    carQueueId?: string;
    carId?: string;
    estimateTime?: Date;
    complete?: string;
    cancel?: string;
    createBy?: string;
    createDate?: Date;
    updateBy?: string;
    updateDate?: Date;
    store?: Store;
    select?: (keyof CarQueue)[];
    order?: { [P in keyof CarQueue]: 'ASC' | 'DESC' | 'asc' | 'desc' | 1 | -1 };
    loadEagerRelations?: boolean;
};

type CreateRequestData = CarQueue & {};

type CreateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: CarQueue;
};

function create(data: CreateRequestData) {
    return fetchWithTimeout('car-queue/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type CreateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: CarQueue[];
};

function createBulk(data: CreateRequestData[]) {
    return fetchWithTimeout('car-queue/createBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type GetRequestData = CarQueue & {
    carQueueIdIn?: string[];
    estimateTimeSt?: Date;
    estimateTimeEd?: Date;
    select?: (keyof CarQueue)[];
    loadEagerRelations?: boolean;
};

type GetResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: CarQueue[];
};

function get(data: GetRequestData) {
    return fetchWithTimeout('car-queue/get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: GetResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateRequestData = CarQueue & { carQueueId: string };

type UpdateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: CarQueue;
};

function update(data: UpdateRequestData) {
    return fetchWithTimeout('car-queue/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: CarQueue[];
};

function updateBulk(data: UpdateRequestData[]) {
    return fetchWithTimeout('car-queue/updateBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type RemoveRequestData = CarQueue & { carQueueId: string };

type RemoveResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: {};
};

function remove(data: RemoveRequestData) {
    return fetchWithTimeout('car-queue/remove', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

function removeBulk(data: RemoveRequestData[]) {
    return fetchWithTimeout('car-queue/removeBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type InformRequestData = { carQueueId: string };

type InformResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: {};
};

function inform(data: InformRequestData) {
    return fetchWithTimeout('car-queue/inform', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: InformResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

export default { create, createBulk, get, update, updateBulk, remove, removeBulk, inform };
